import React, { useRef, useState } from 'react';
import { read, utils } from 'xlsx';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useNavigate } from 'react-router-dom';
import { FormActions } from '../../componants/Workspace';

const ExcelInvitations = () => {
  const fileInputRef = useRef(null);
  const { SetNotification } = useStateContext();

  const navigate = useNavigate();
  const [progress, setProgress] = useState(0); // State to track the progress

  const handleSubmit = async (e) => {
    e.preventDefault();

    const file = fileInputRef.current.files[0]; // Get the selected file from the file input
    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = read(data, { type: 'array' }); // Read the Excel file

      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = utils.sheet_to_json(worksheet, { header: 1 });
      const firstColumnValues = jsonData.map((row) => row[0]);

      // Calculate the progress step based on the number of values
      const progressStep = 100 / firstColumnValues.length;

      for (const value of firstColumnValues) {
        const payload = {
          title: value,
          expiration: 'your expiration value here',
        };

        try {
          await AxiosClient.post('/invitations', payload);
          SetNotification('Invitation code has been generated successfully', 'success');
          navigate(-1);
        } catch (error) {
          if (error.response && error.response.data && error.response.data.message) {
            const errorMessage = error.response.data.message;
            SetNotification(errorMessage, 'danger');
          } else {
            SetNotification('An error occurred while creating the invitation.', 'danger');
          }
        }

        // Update the progress state after each iteration
        setProgress((prevProgress) => prevProgress + progressStep);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div className="m-4">
      <form onSubmit={handleSubmit} className="form-group">
        <div className="input-group input-group-outline mb-3">
          <input type="file" className="form-control m-2" ref={fileInputRef} />
        </div>
        <FormActions>
          <button type="submit" className="btn btn-primary">
            Import invitation codes
          </button>
        </FormActions>
      </form>

      <ProgressBar now={progress} label={`${progress}%`} /> {/* Display the progress bar */}
    </div>
  );
};

export default ExcelInvitations;